module.exports = "images/10ans.b91a4f8b.png";